export type PaymentMethodsImageBased =
  | 'amex'
  | 'diners'
  | 'discover'
  | 'klarna_sofort'
  | 'mastercard'
  | 'paydirekt'
  | 'paypal'
  | 'ideal'
  | 'visa'
  | 'mastercard_clicktopay'
  | 'visa_clicktopay'
  | 'clicktopay'
  | 'wero';

export type PaymentMethodsTextBased = 'bank_debit' | 'flexikonto' | 'installments' | 'invoice';

// The order of the entries in the array determine the order in which the payment methods are presented to the user.
export type PaymentMethodsConfig = {
  paymentMethods: {
    imageBased: PaymentMethodsImageBased[];
    textBased: PaymentMethodsTextBased[];
  };
  /**
   * ORDER-4147: when `true`, the payment page renders the "Bonität vorausgesetzt" credit-check
   * hint on the invoice and installments cards (including while those cards are inactive).
   * Defaults to `false`; only BAUR and QDE opt in.
   */
  showCreditCheckHint: boolean;
  /**
   * IOGZ-434: when `true`, the check-and-order page renders the Ratenbeispiel (InstallmentExample)
   * for the revolving-credit payment type. Defaults to `false`; only QDE opts in.
   */
  showInstallmentExample: boolean;
};

export const paymentMethodsConfig: PaymentMethodsConfig = {
  paymentMethods: {
    imageBased: ['visa', 'mastercard', 'diners', 'discover', 'paypal'],
    textBased: ['invoice', 'flexikonto'],
  },
  showCreditCheckHint: false,
  showInstallmentExample: false,
};
